export default __webpack_public_path__ + "static/media/logo.cb680a3a.png";